export default __webpack_public_path__ + "static/media/map-main-marker.icon.10479e2b.svg";